/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import API from '@aws-amplify/api'
import moment from 'moment'
import { FlatfileButton, IDataHookResponse } from '@flatfile/react'
import { Typography } from '@material-ui/core'
import Layout from '../../components/Dashboard/newLayout'
import './styles.scss'

function getNextSendDateFromDate(sendDate): moment.Moment {
  let tomorrowOrNextWeekday = moment(sendDate)
  if (tomorrowOrNextWeekday.day() === 0) {
    // Custom send date is Sunday, add one day to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(1, 'day')
  } else if (tomorrowOrNextWeekday.day() === 6) {
    // Custom send date is Saturday, add two days to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(2, 'days')
  }
  return tomorrowOrNextWeekday
}

export default function Leads(props: any): JSX.Element {
  const { setIsAuthenticated } = props
  const isWeekday = (date: Date): boolean => {
    console.log('in weekday', date, date.getDay())
    const day = date.getDay()
    return day !== 0 && day !== 6
  }
  let globalNextSend: any = getNextSendDateFromDate(
    moment()
      .add(1, 'day')
      .toDate(),
  )
  const tomorrow = moment()
    .add(1, 'day')
    .toDate()
  let tomorrowOrNextWeekday = moment(tomorrow)
  if (tomorrowOrNextWeekday.day() === 0) {
    // Custom send date is Sunday, add one day to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(1, 'day')
  } else if (tomorrowOrNextWeekday.day() === 6) {
    // Custom send date is Saturday, add two days to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(2, 'days')
  }
  const DAILY_SEND_LIMIT = 50
  const dayCounts = {}
  const primaryButton = {
    backgroundColor: '#FFF',
    color: '#27a9e0',
    border: '1px solid #27a9e0',
    padding: '6px 16px',
    fontSize: '15px',
    borderRadius: '8px',
    ':hover': {
      backgroundColor: '#27a9e0',
      color: '#FFF',
      border: '2px solid #FFF',
    },
  }

  const secondaryButton = {
    backgroundColor: 'transparent',
    color: '#58585b',
    border: '1px solid #58585b',
    padding: '6px 16px',
    fontSize: '15px',
    borderRadius: '8px',
    ':hover': {
      backgroundColor: '#00c6ff',
      border: '1px solid #00c6ff',
      color: '#002d3d',
    },
  }
  return (
    <Layout title="Add Bulk Contacts" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="bulk-body">
          <div className="add">
            <h2>Hello!</h2>
            <Typography>
              Click below to upload your list of contacts as a data file (.csv, .tsv, .xls, .xlsx,
              .xml, or .txt) to MaverickApp.
            </Typography>
            <div className="btn-container">
              <FlatfileButton
                licenseKey="b36ed275-3feb-46cf-bc34-c6154624a027"
                customer={{ userId: '12345' }}
                settings={{
                  theme: {
                    header: {
                      root: {
                        backgroundColor: '#59595b',
                        margin: '0 0 10px 0',
                      },
                      title: {
                        color: 'white',
                      },
                      closeButton: {
                        color: 'white',
                        ':hover': {
                          color: 'red',
                        },
                      },
                    },
                    dropzone: {
                      content: {
                        border: 'none',
                      },
                    },
                    global: {
                      backgroundColor: '#FFF',
                      textColor: '#000',
                      primaryTextColor: 'lightgray',
                      secondaryTextColor: '#27a9e0',
                      successColor: '#27a9e0',
                      warningColor: '#c2c3c3',
                      fontFamily: 'Manrope',
                    },
                    buttons: {
                      primary: primaryButton,
                      secondary: secondaryButton,
                      success: primaryButton,
                      headerMatchYes: {
                        ...primaryButton,
                        padding: '6px 40px',
                      },
                      headerMatchNo: {
                        ...secondaryButton,
                        padding: '6px 40px',
                      },
                    },
                    // other keys below
                  },
                  type: 'Contact',
                  title: 'ADD BULK CONTACTS',
                  fields: [
                    {
                      label: 'Email',
                      key: 'email',
                      validators: [{ validate: 'required' }, { validate: 'unique' }],
                    },
                    {
                      label: 'First Name',
                      key: 'firstName',
                      validators: [
                        {
                          validate: 'required',
                        },
                      ],
                    },
                    {
                      label: 'Last Name',
                      key: 'lastName',
                      validators: [
                        {
                          validate: 'required',
                        },
                      ],
                    },
                    {
                      label: 'Company',
                      key: 'company',
                    },
                    {
                      label: 'Title',
                      key: 'title',
                    },
                    {
                      label: 'Phone',
                      key: 'phone',
                    },
                    {
                      label: 'Industry',
                      key: 'industry',
                    },
                    {
                      label: 'Website',
                      key: 'website',
                    },
                    {
                      label: 'Status',
                      key: 'status',
                      type: 'select',
                      options: [
                        {
                          value: 'emailScheduled',
                          label: 'Email Scheduled',
                        },
                        {
                          value: 'dne',
                          label: 'Do Not Engage',
                        },
                        {
                          value: 'new',
                          label: 'New',
                        },
                      ],
                    },
                    {
                      label: 'Maneuver',
                      key: 'maneuver',
                      type: 'select',
                      options: [
                        {
                          value: 'firstTouch',
                          label: 'First Touch',
                        },
                        {
                          value: 'followUp',
                          label: 'Follow Up',
                        },
                        {
                          value: 'nurture',
                          label: 'Nurture',
                        },
                      ],
                      validators: [
                        {
                          validate: 'required_with_values',
                          fieldValues: { status: 'emailScheduled' },
                        },
                      ],
                    },
                    {
                      label: 'Mission',
                      key: 'mission',
                      type: 'select',
                      options: [
                        {
                          value: 'Mission 1',
                          label: 'Mission 1',
                        },
                        {
                          value: 'Mission 2',
                          label: 'Mission 2',
                        },
                        {
                          value: 'Mission 3',
                          label: 'Mission 3',
                        },
                        {
                          value: 'Mission 4',
                          label: 'Mission 4',
                        },
                      ],
                      validators: [
                        {
                          validate: 'required_with_values',
                          fieldValues: { status: 'emailScheduled' },
                        },
                      ],
                    },
                    {
                      label: 'Send Date',
                      key: 'sendDate',
                      validators: [
                        {
                          validate: 'required_with_values',
                          fieldValues: { status: 'emailScheduled' },
                        },
                      ],
                    },
                    {
                      label: 'Notify When Mission Completes',
                      key: 'notifyOnComplete',
                      type: 'checkbox',
                    },
                  ],
                  managed: true,
                }}
                onData={async (localResults): Promise<void> => {
                  // do something with the results
                  console.log(localResults)
                  // eslint-disable-next-line dot-notation
                  const result = localResults['$data'].filter(record => record.valid)
                  console.log(localResults)
                  const myInit = { body: result }
                  await API.post('mav-outlook-api', '/leads/import', myInit)
                }}
                onRecordChange={(record): IDataHookResponse => {
                  const response: any = {}
                  // console.log('at init', record)

                  if (record.email && record.email.toString().toLowerCase() !== record.email) {
                    response.email = {
                      value: record.email?.toLocaleString().toLocaleLowerCase(),
                      info: [{ message: 'converted to lowercase', level: 'info' }],
                    }
                  }
                  if (record.sendDate) {
                    let localSendDate = record.sendDate
                    if (
                      !moment(localSendDate.toString(), 'MM/DD/YYYY', true).isValid() ||
                      moment(localSendDate?.toString()).isBefore(new Date(), 'day') ||
                      moment(localSendDate.toString()).isBefore(globalNextSend, 'day') ||
                      (localSendDate && !isWeekday(new Date(localSendDate.toLocaleString())))
                    ) {
                      localSendDate = getNextSendDateFromDate(globalNextSend).format('MM/DD/YYYY')
                    }
                    if (dayCounts[JSON.stringify(localSendDate)]) {
                      if (dayCounts[JSON.stringify(localSendDate)] === DAILY_SEND_LIMIT) {
                        localSendDate = getNextSendDateFromDate(
                          moment(globalNextSend, 'MM/DD/YYYY').add(1, 'days'),
                        ).format('MM/DD/YYYY')
                        globalNextSend = localSendDate
                        dayCounts[JSON.stringify(localSendDate)] = 1
                      } else {
                        dayCounts[JSON.stringify(localSendDate)] += 1
                      }
                    } else {
                      dayCounts[JSON.stringify(localSendDate)] = 1
                    }
                    if (localSendDate !== record.sendDate) {
                      response.sendDate = {
                        value: localSendDate,
                        info: [
                          {
                            message: `Send date must be in the future and a weekday. You may only schedule ${DAILY_SEND_LIMIT} a day`,
                            level: 'info',
                          },
                        ],
                      }
                    }
                  }
                  if (record.status !== 'emailScheduled') {
                    response.maneuver = {
                      value: null,
                    }
                    response.sendDate = {
                      value: null,
                    }
                    response.mission = {
                      value: null,
                    }
                  }
                  return response
                }}
                onRecordInit={(record): IDataHookResponse => {
                  const response: any = {}
                  if (record.email && record.email.toString().toLowerCase() !== record.email) {
                    response.email = {
                      value: record.email?.toLocaleString().toLocaleLowerCase(),
                      info: [{ message: 'converted to lowercase', level: 'info' }],
                    }
                  }
                  if (record.sendDate) {
                    let localSendDate = record.sendDate
                    if (
                      !moment(localSendDate.toString(), 'MM/DD/YYYY', true).isValid() ||
                      moment(localSendDate?.toString()).isBefore(new Date(), 'day') ||
                      moment(localSendDate.toString()).isBefore(globalNextSend, 'day') ||
                      (localSendDate && !isWeekday(new Date(localSendDate.toLocaleString())))
                    ) {
                      localSendDate = getNextSendDateFromDate(globalNextSend).format('MM/DD/YYYY')
                    }
                    if (dayCounts[JSON.stringify(localSendDate)]) {
                      if (dayCounts[JSON.stringify(localSendDate)] === DAILY_SEND_LIMIT) {
                        localSendDate = getNextSendDateFromDate(
                          moment(globalNextSend, 'MM/DD/YYYY').add(1, 'days'),
                        ).format('MM/DD/YYYY')
                        globalNextSend = localSendDate
                        dayCounts[JSON.stringify(localSendDate)] = 1
                      } else {
                        dayCounts[JSON.stringify(localSendDate)] += 1
                      }
                    } else {
                      dayCounts[JSON.stringify(localSendDate)] = 1
                    }
                    if (localSendDate !== record.sendDate) {
                      response.sendDate = {
                        value: localSendDate,
                        info: [
                          {
                            message: `Send date must be in the future and a weekday. You may only schedule ${DAILY_SEND_LIMIT} a day`,
                            level: 'info',
                          },
                        ],
                      }
                    }
                  }
                  if (record.status !== 'emailScheduled') {
                    response.maneuver = {
                      value: null,
                    }
                    response.sendDate = {
                      value: null,
                    }
                    response.mission = {
                      value: null,
                    }
                  }
                  console.log({ globalNextSend })

                  return response
                }}
                render={(importer, launch) => {
                  // eslint-disable-next-line @typescript-eslint/camelcase
                  importer?.registerStepHook('review', ({ headers_matched }) => {
                    console.log(headers_matched)
                    if (!headers_matched?.find(v => v.matched_key === 'status')) {
                      importer.addVirtualField(
                        {
                          label: 'Status',
                          key: 'status',
                          type: 'select',
                          description: 'Status is a required field',
                          options: [
                            {
                              value: 'emailScheduled',
                              label: 'Email Scheduled',
                            },
                            {
                              value: 'dne',
                              label: 'Do Not Engage',
                            },
                            {
                              value: 'new',
                              label: 'New',
                            },
                          ],
                          validators: [
                            {
                              validate: 'required',
                            },
                          ],
                        },
                        {
                          order: 10,
                        },
                      )
                    }
                    if (!headers_matched?.find(v => v.matched_key === 'maneuver')) {
                      importer.addVirtualField(
                        {
                          label: 'Maneuver',
                          key: 'maneuver',
                          type: 'select',
                          options: [
                            {
                              value: 'firstTouch',
                              label: 'First Touch',
                            },
                            {
                              value: 'followUp',
                              label: 'Follow Up',
                            },
                            {
                              value: 'nurture',
                              label: 'Nurture',
                            },
                          ],
                          validators: [
                            {
                              validate: 'required_with_values',
                              fieldValues: { status: 'emailScheduled' },
                            },
                          ],
                        },
                        {
                          order: 11,
                        },
                      )
                    }
                    if (!headers_matched?.find(v => v.matched_key === 'mission')) {
                      importer.addVirtualField(
                        {
                          label: 'Mission',
                          key: 'mission',
                          type: 'select',
                          options: [
                            {
                              value: 'Mission 1',
                              label: 'Mission 1',
                            },
                            {
                              value: 'Mission 2',
                              label: 'Mission 2',
                            },
                            {
                              value: 'Mission 3',
                              label: 'Mission 3',
                            },
                            {
                              value: 'Mission 4',
                              label: 'Mission 4',
                            },
                          ],
                          validators: [
                            {
                              validate: 'required_with_values',
                              fieldValues: { status: 'emailScheduled' },
                            },
                          ],
                        },
                        {
                          order: 12,
                        },
                      )
                    }
                    if (!headers_matched?.find(v => v.matched_key === 'sendDate')) {
                      importer.addVirtualField(
                        {
                          label: 'Send Date',
                          key: 'sendDate',
                          validators: [
                            {
                              validate: 'required_with_values',
                              fieldValues: { status: 'emailScheduled' },
                            },
                          ],
                        },
                        {
                          order: 13,
                        },
                      )
                    }
                    if (!headers_matched?.find(v => v.matched_key === 'notifyOnComplete')) {
                      importer.addVirtualField(
                        {
                          label: 'Notify When Mission Completes',
                          key: 'notifyOnComplete',
                          type: 'checkbox',
                        },
                        {
                          order: 14,
                        },
                      )
                    }
                    return true
                  })
                  // eslint-disable-next-line react/button-has-type
                  return (
                    <button
                      onClick={() => {
                        launch()
                      }}
                      type="button"
                    >
                      Get started
                    </button>
                  )
                }}
              >
                Get started
              </FlatfileButton>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
